import * as Scrivito from "scrivito";

function LanguageSwitchItem({ destination, className, language, currentPage }) {
  if (currentPage.id() !== destination?.id()) {
    return (
      <Scrivito.LinkTag to={destination} className={className}>
        {language}
      </Scrivito.LinkTag>
    );
  }

  return <span className={className}>{language}</span>;
}
export default Scrivito.connect(LanguageSwitchItem);
